/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getId } from '../../utils/item';
import { LinkOneLine } from './link.OneLine';
import { BtnSimple } from '../form/btn.Simple';
import { setOpenModales } from '../../store/global';
import { LinkNew } from './link.New';

export const LinkExpandable = props => {
  const { itemId, linkId, deleteLink } = props;

  const link = useSelector(state => state.items[linkId]);
  const item = useSelector(state => state.items[itemId]);
  const isMobile = useSelector(state => state.global.isMobile);
  const dispatch = useDispatch();

  const [expand, setExpand] = useState(false);

  return (
    <div className='flex flex-wrap gap-05 items-center mx-1'>
      {!isMobile && <LinkNew itemId={linkId} />}
      <div
        className={`transition ${
          link?.links?.length > 1
            ? 'opacity-50 hover-opacity-100 cursor-pointer'
            : 'opacity-0'
        }`}
        onClick={() => {
          if (link?.links?.length > 1) {
            setExpand(!expand);
          }
        }}
      >
        {expand ? <FaChevronDown /> : <FaChevronUp />}
      </div>
      <LinkOneLine
        linkId={linkId}
        deleteLink={deleteLink}
      />
      <div className='w-full ml-5'>
        {expand && (
          <div>
            <BtnSimple
              onClick={() =>
                dispatch(setOpenModales({ id: 'addLink' + linkId, open: true }))
              }
            >
              ajouter un lien à {link.label}
            </BtnSimple>
            {link?.links?.map(linkedLink => {
              let display = true;
              const linkId = getId(linkedLink);
              if (linkId === item?._id || link?._id === linkId) {
                display = false;
              }
              if (display === true) {
                return (
                  <div key={linkId}>
                    {/* <LinkOneLine linkId={linkId} /> */}
                    <LinkExpandable
                      linkId={linkId}
                      itemId={itemId}
                    />
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
};
